import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	text-align: center;
	max-width: 930px;
	margin: 0 auto;

	h1 {
		margin: 0 auto;
		font-size: ${CSSVars.fontSize2XL};
		font-weight: 600;
		max-width: 750px;
		margin-bottom: 20px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSize4XL};
		}
	}

	h5 {
		margin: 0 auto;
		font-size: ${CSSVars.fontSizeLG};
		font-weight: 300;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSizeXL};
		}
	}

	.tags {
		margin-top: 50px;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 10px;

		.tag {
			padding: 5px 15px 3px 15px;
			border-radius: 20px;
			border: 1px solid ${CSSVars.primary300};
			color: ${CSSVars.primary300};
			font-size: ${CSSVars.fontSizeXS};
			transition: 0.2s;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeSM};
			}

			&:hover {
				border: 1px solid ${CSSVars.primary500};
				color: ${CSSVars.primary500};
			}
		}
	}

	#tableWrapper {
		overflow: auto !important;
		max-width: 640px;
	}

	deckgo-highlight-code {
		width: 100%;
		max-width: 640px;
	}

	span.code {
		background: rgba(0, 0, 0, 0.05);
		padding: 2px 5px;
		border: 1px solid rgba(0, 0, 0, 0.1);
		margin: 0 2px;
		border-radius: 2px;
	}

	img {
		text-align: center;
		height: 100%;

		&:first-of-type {
			> * {
				width: 100% !important;
			}
		}
	}

	.blog-post-content {
		font-family: ${CSSVars.secondaryFont};
		line-height: 1.7;
		text-align: left;
		max-width: 930px;

		p {
			margin: 20px 0;
			font-size: ${CSSVars.fontSizeMD};

			br {
				display: none;
			}

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeLG};
			}
		}

		h2 {
			font-size: ${CSSVars.fontSizeXL};
			font-weight: 700;
			line-height: 1.7em;
			margin-top: 40px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSize2XL};
			}
		}

		h3,
		h4,
		h5,
		h6 {
			font-size: ${CSSVars.fontSizeLG};
			font-weight: 600;
			line-height: 1.7em;
			margin-top: 40px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeXL};
			}
		}

		.content-layout {
			display: flex;
			gap: 30px;
			flex-direction: column;

			img {
				max-height: 350px;
			}

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				gap: 50px;
				flex-direction: row;
			}

			.side-banner {
				height: fit-content;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					max-width: 240px;
					position: sticky;
					top: 10px;
				}

				.banner {
					@media screen and (max-width: ${CSSVars.breakpointMD}) {
						display: none;
					}

					margin-top: 20px;
					padding: 20px;
					border-radius: 10px;

					img {
						object-fit: cover;
						border-radius: 5px;
						height: 100px;
						max-width: 100%;
						width: 100%;
						margin: 0;
					}

					.title {
						margin: 0;
						font-size: 16px;
						font-weight: 600;
					}

					.text {
						font-weight: 300;
						font-size: 14px;
						margin: 5px 0 0;
					}

					a {
						margin-top: 20px;
						padding: 5px 15px;
						width: 100%;
					}
				}

				.table-of-contents {
					max-width: 100%;
					width: 100%;
					background-color: ${CSSVars.gray100};
					border: 1px solid ${CSSVars.gray200};
					border-radius: 10px;
					padding: 20px 10px;
					display: flex;
					flex-direction: column;

					.title {
						font-weight: 600;
						font-size: 16px;
						margin: 0 0 10px;
						padding: 0 10px;
						color: #030303;
					}

					a {
						font-weight: 400;
						font-size: 14px;
						padding: 5px 10px;
						border-radius: 5px;
						margin-bottom: 2px;
						text-decoration: none;

						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 1; /* number of lines to show */
						line-clamp: 1;
						-webkit-box-orient: vertical;
						transition: 0.2s;

						&.active {
							background: #e7e7f4;
						}
					}
				}
			}

			main.content {
				flex: 1;
			}
		}

		.cta {
			padding: 10px 20px;
			margin: 0 auto;

			&.button,
			&.download {
				text-decoration: none !important;
				color: white;
				background-color: ${CSSVars.primary500};
			}

			&.link {
				font-size: 18px;
				color: ${CSSVars.primary500};
				background: none;
			}
		}

		.html {
			width: 100%;
			border-radius: 5px;
			min-height: unset;
			max-width: 930px;
			height: fit-content;
		}

		.quotes-container {
			display: flex;
			gap: 40px;
			margin: 20px 0;

			img {
				width: 40px;
				height: 40px;
				border-radius: 10px;
				object-fit: cover;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					width: 65px;
					height: 65px;
				}
			}

			p {
				color: #141414;
				position: relative;
				margin: 0;

				span {
					font-weight: 600;
					margin-bottom: 5px;
					display: block;
				}

				&::before {
					content: '';
					position: absolute;
					left: -20px;
					border: 1px solid ${CSSVars.primary500};
					top: 0;
					bottom: 0;
				}
			}
		}

		.banner-container {
			h3 {
				margin: 0 auto;
				font-size: ${CSSVars.fontSize2XL};
				text-align: center;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSize4XL};
				}
			}

			a {
				color: white;
				padding: 10px 20px;
				text-decoration: none !important;
			}
		}
		.tldr {
			margin-top: 30px;
			border-radius: 10px;
			background-color: ${CSSVars.gray100};
			font-size: ${CSSVars.fontSizeMD};
			font-weight: 300;
			padding: 20px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				padding: 30px 50px;
				font-size: ${CSSVars.fontSizeLG};
			}

			span {
				font-weight: 600;
			}
		}

		img {
			&.main-img {
				width: 930px;
				border-radius: 10px;
				margin: 30px 0;
				max-width: 100%;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					margin: 50px 0;
				}
			}
		}

		table {
			border-collapse: collapse;
			width: 100%;
			& td,
			& th {
				border: 1px solid #ddd;
				padding: 8px;
			}

			& tr:nth-child(odd) {
				background-color: #f2f2f2;
			}

			& tr:nth-child(1) {
				background-color: #454545;
				color: rgb(240, 240, 240);
			}

			& th {
				padding-top: 12px;
				padding-bottom: 12px;
				text-align: left;
				background-color: #04aa6d;
				color: white;
			}
		}

		blockquote {
			position: relative;
			&::before {
				content: '';
				position: absolute;
				left: -10px;
				border: 1px solid ${CSSVars.primary500};
				top: 0;
				bottom: 0;
			}
		}

		.wp-block-buttons {
			&.aligncenter {
				margin: 40px auto;
			}
			.wp-block-button__link {
				color: white;
				padding: 1rem 2rem;
				background: ${CSSVars.primary500};
				font-size: ${CSSVars.fontSizeSM};
				border-radius: 9px !important;
				text-decoration: none;
				transition: 0.2s;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeMD};
				}

				&:hover {
					transform: translateY(4px);
				}
			}
		}

		img {
			margin: 20px 0;

			&.infographic {
				span {
					width: 450px !important;
					@media screen and (max-width: 550px) {
						width: 100%;
					}
				}
			}
			img {
				max-width: 100%;
				height: auto;
			}
		}

		.wp-block-embed {
			margin: 0 0 20px;
			text-align: center;
		}

		figcaption {
			color: ${CSSVars.gray400};
			font-style: italic;
			font-size: 16px;
			text-align: center;
		}

		img {
			max-width: 100%;
		}

		a {
			color: ${CSSVars.primary500};
			padding: 11px 0;

			&:hover {
				text-decoration: underline;
			}
		}

		ul,
		ol {
			margin: 20px 0;
			padding: 0 30px;
		}

		ul {
			list-style: disc;
		}

		ol {
			list-style: decimal;
		}

		li {
			margin-bottom: 10px;
			font-size: ${CSSVars.fontSizeMD};

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeLG};
			}

			&:last-child {
				margin-bottom: 0;
			}
		}
	}

	.might-like {
		margin-top: 10rem !important;
		margin: auto;
		text-align: center;

		h3 {
			font-size: ${CSSVars.fontSize2XL};
			font-weight: 600;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSize3XL};
			}
		}

		.post-cards-wrapper {
			max-width: 930px;
			display: flex;
			flex-wrap: wrap;
			gap: 50px;
			margin: 50px 0 100px;

			justify-content: center;

			a {
				text-decoration: none;
			}

			.post-card {
				align-items: stretch;
				display: flex;
				flex-direction: column;
				gap: 10px;
				align-items: center;
				color: ${CSSVars.gray900};

				img {
					max-width: 100%;
					border-radius: 10px;
					object-fit: cover;
					margin: 0;

					max-width: 100%;
					@media screen and (min-width: ${CSSVars.breakpointMD}) {
						max-width: 275px;
					}
				}

				h4 {
					align-self: flex-start;
					text-align: left;
					font-weight: 600;
					line-height: normal;
					max-width: 100%;
					font-size: ${CSSVars.fontSizeSM};

					@media screen and (min-width: ${CSSVars.breakpointMD}) {
						font-size: ${CSSVars.fontSizeMD};
						max-width: 240px;
					}
				}
			}
		}
	}
`;
